import storage from 'store'
import { useRootStore } from '@/stores/root'
import http from './http'

// Port di services/authentication.js (Vue 2/Vuex) → Vue 3/Pinia.
// store.dispatch('setIsLoading', x) → useRootStore().setIsLoading(x)
// store.getters.user → useRootStore().user
export default {
  async checkPassword({ password }) {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const response = await http.request({
        method: 'post',
        path: '/auth/checkPassword',
        data: {
          username: rootStore.user.username,
          idsocieta: rootStore.user.idsocieta,
          password,
        },
      })
      return response
    } catch (err) {
      return Promise.reject(err.message)
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  async login({ email, password, society }) {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const user = await http.request({
        method: 'post',
        path: '/auth/login',
        data: {
          email,
          password,
          ...(society && { societa: society }),
        },
      })
      return user
    } catch {
      return null
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  async firstAccess({ password, confirmPassword }) {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const response = await http.request({
        method: 'post',
        path: '/auth/firstAccess',
        data: {
          idsession_txt: rootStore.user.userId,
          password1: password,
          password2: confirmPassword,
        },
      })
      return response
    } catch {
      return null
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  async expiredPassword({ password, confirmPassword }) {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const response = await http.request({
        method: 'post',
        path: '/auth/expiredPassword',
        data: {
          idsession_txt: rootStore.user.userId,
          password1: password,
          password2: confirmPassword,
        },
      })
      return response
    } catch {
      return null
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  async recoveryPassword({ email }) {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const response = await http.request({
        method: 'post',
        path: '/auth/recoveryPassword',
        data: {
          email,
          url: import.meta.env.VITE_RESET_PASSWORD_REDIRECT_URL,
        },
      })
      return response
    } catch {
      return null
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  async resetPassword({ userId, password, confirmPassword, token }) {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const response = await http.request({
        method: 'post',
        path: '/auth/recoveryPassword2',
        data: {
          idsession_txt: userId,
          password1: password,
          password2: confirmPassword,
          token,
        },
      })
      return response
    } catch {
      return null
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  async checkAuth() {
    const rootStore = useRootStore()
    try {
      rootStore.setIsLoading(true)
      const user = await http.request({
        method: 'get',
        path: '/auth/login',
      })
      return user
    } catch {
      return null
    } finally {
      rootStore.setIsLoading(false)
    }
  },
  logout() {
    sessionStorage.clear()
    storage.remove('authToken')
  },
  setUserSociety(societyCode) {
    const rootStore = useRootStore()
    storage.set(`society:${rootStore.user.email}`, societyCode)
  },
  getUserSociety() {
    const rootStore = useRootStore()
    return storage.get(`society:${rootStore.user.email}`)
  },
}
